import axios from "axios"
import AccidentUpsellData from './AccidentUpsellData';

export default function(config) {
    return {
        ...AccidentUpsellData(config.endpoints && config.endpoints.accident_price),

        subject_name: '',
        price: '',
        veterinary_care_insurance_name: '',
        life_insurance_name: '',
        veterinary_care_insurance_documents: [],
        life_insurance_documents: [],
        insurance_start_date: '',
        veterinary_care_deductible: '',
        insurance_amount: '',
        life_insurance: '',
        veterinary_care_insurance: '',
        veterinary_care: '',
        veterinary_care_insurance_active: '',
        life_insurance_active: '',
        chip: '',
        born: '',
        email: '',
        phone: '',
        first_name: '',
        last_name: '',
        personal_number: '',
        payment_method: 'focus',
        payment_interval: '1',
        accept_terms: false,
        loading: false,
        price_loading: false,

        insurance_accordion_open: false,
        subject_accordion_open: false,
        user_accordion_open: false,

        // New summary design state
        new_summary: config.new_summary || false,
        summary_open: false,
        details_open: false,

        endpoints: config.endpoints,
        errors: {},
        submit_error: null,

        intervalSuffix() {
            return {
                '1': 'mån',
                '3': 'kvartal',
                '12': 'år',
            }[this.payment_interval] || 'mån';
        },

        // Re-fetch the real price from Focus for the chosen interval. Focus prices the
        // insurance per payment term (e.g. invoicing fees for monthly), so the amount
        // due each period is computed server-side and returned ready to display.
        updatePrice() {
            if (!this.endpoints.price) {
                return;
            }

            // Flag loading so the summary shows the "Räknar ut pris..." indicator
            // instead of the previous interval's amount while the new price is fetched.
            this.price_loading = true;

            clearTimeout(this.update_price_timeout);
            this.update_price_timeout = setTimeout(() => {
                axios.post(this.endpoints.price, {
                    payment_interval: this.payment_interval,
                }).then(response => {
                    this.price = response.data.price;
                }).catch(error => {
                    console.error(error);
                }).finally(() => {
                    this.price_loading = false;
                });
            }, 200);
        },

        init() {
            this.bankid.init();
            this.initAccidentUpsell();

            // Show the loading state immediately — the price carried over from the
            // previous step is replaced by a fresh fetch for the selected interval.
            if (this.endpoints.price) {
                this.price_loading = true;
            }

            this.getData().then(() => {
                this.getMeta();
                this.updatePrice();

                if (this.new_summary) {
                    this.details_open = !this.email || !this.phone;
                } else {
                    this.subject_accordion_open = !this.chip;
                    this.user_accordion_open = !this.email || !this.phone;
                }
            });

            this.$watch(() => this.bankid.status_message, status => {
                if (status === 'ERROR') {
                    this.bankid.cancel();
                    this.loading = false;
                    this.submit_error = true;
                }
            });

            this.$watch(() => this.payment_interval, () => {
                this.updatePrice();
            });

            this.$watch(() => this.email, email => {
                if (email) {
                    this.errors.email = null;
                }
            });

            this.$watch(() => this.phone, phone => {
                if (phone) {
                    this.errors.phone = null;
                }
            });

            this.$watch(() => this.errors, errors => {
                if (!errors) {
                    return;
                }

                if (errors['chip']) {
                    this.subject_accordion_open = true;
                }

                if (errors['email'] || errors['phone']) {
                    this.user_accordion_open = true;
                    this.details_open = true;
                }
            });

            if (this.datalayer) {
                let datalayer_object = JSON.parse(JSON.stringify(this.datalayer));
                dataLayer.push(datalayer_object);
            }
        },

        async save() {
            this.errors = {};
            this.loading = true;

            try {
                const response = await axios.post(this.endpoints.save, {
                    accept_terms: this.accept_terms,
                    payment_method: this.payment_method,
                    payment_interval: this.payment_interval,
                    email: this.email,
                    phone: this.phone,
                    chip: this.chip,
                    accident_insurance: this.accident_insurance,
                });

                if (response.data.redirect) {
                    window.location.href = response.data.redirect;
                    return;
                }

                this.loading = false;

                this.bankid.sign(
                    this.endpoints.bankid_sign,
                    this.endpoints.bankid_cancel,
                    this.endpoints.bankid_status
                ).catch(error => {
                    this.bankid.cancel();
                    this.loading = false;

                    if (error.response && error.response.data && error.response.data.errors && error.response.data.errors['submit_error']) {
                        this.submit_error = error.response.data.errors['submit_error'];
                    }
                });
            } catch (error) {
                this.errors = error.response.data ? error.response.data.errors : {};
                this.loading = false;

                if (this.errors && Object.keys(this.errors).length > 0) {
                    if (error.response.data.errors['submit_error']) {
                        this.submit_error = error.response.data.errors['submit_error'];
                    }

                    setTimeout(() => {
                        window.scrollto.selector('[name='+ Object.keys(this.errors)[0] +']', 120);
                    }, 250);
                }
            }
        },

        getData() {
            return new Promise((resolve, reject) => {
                axios.post(this.endpoints.data, {

                }).then(response => {
                    let data = response.data;
                    
                    for (let key in data) {
                        this[key] = data[key];
                    }

                    resolve();
                }).catch(error => {
                    console.error(error);
                    reject();
                });
            });
        },

        getMeta() {
            axios.post(this.endpoints.meta, {
                veterinary_care_insurance: this.veterinary_care_insurance,
                life_insurance: this.life_insurance,
                veterinary_care_insurance_active: this.veterinary_care_insurance_active,
                life_insurance_active: this.life_insurance_active
            }).then(response => {
                let data = response.data;
                    
                for (let key in data) {
                    this[key] = data[key];
                }
            }).catch(error => {
                console.error(error);
            });
        }
    }
}